/* eslint-disable react/prop-types */
/* eslint-disable react/function-component-definition */

import React, { useEffect, useState } from "react";
// @mui material components
import Card from "@mui/material/Card";
import Grid from "@mui/material/Grid";
import Button from "@mui/material/Button";
import TextField from "@mui/material/TextField";
import Select from "@mui/material/Select";
import MenuItem from "@mui/material/MenuItem";
import Input from "@mui/material/Input";
import Typography from "@mui/material/Typography";
import FormControl from "@mui/material/FormControl";
import InputLabel from "@mui/material/InputLabel";

// Material Dashboard 2 React components
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MDButton from "components/MDButton";

// Material Dashboard 2 React context
import { useMaterialUIController } from "context";
import apiClient from "../../../../../apiClient";

function AddBanner({ onClose, onSuccess, onFailed, editFormData }) {
  const [controller] = useMaterialUIController();
  const { darkMode } = controller;
  const [property, setProperty] = useState([]);
  const [editData, setEditData] = useState(editFormData);

  const getProperty = async () => {
    const response = await apiClient.get("/admin/listings");
    if (response.status === 200) {
      setProperty(response.data);
    }
  };

  useEffect(() => {
    getProperty();
  }, []);

  const [formData, setFormData] = useState({
    property: editData ? editData.property : "",
    images: editData ? editData.images : "",
    sort: editData ? editData.sort : "",
    status: editData.status || "Active",
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value,
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    // Handle form submission logic here
    const isEdit = editData && Object.keys(editData).length > 0; // Check if editData exists
    try {
      const payload = {
        property: formData.property,
        images: formData.images,
        sort: formData.sort,
        status: formData.status,
      };
      if (!payload.property || !payload.images || !payload.sort || !payload.status) {
        console.error("Please fill all the fields");
        onFailed("Please fill all the fields");
        onClose();
        return;
      }
      const endpoint = isEdit ? `/admin/banners/update/${editData._id}` : "/admin/banners"; // Use ID for PUT
      const method = isEdit ? apiClient.put : apiClient.post; // PUT for edit, POST for create

      // Make the API request
      const response = await method(endpoint, formData);
      if (response.status === 200) {
        if (response.data.status === "success") {
          onSuccess();
          onClose();
        } else if (response.data.status === "false") {
          console.error("Error creating room type:", response.data.message);
          // showing failed message in snackbar
          onFailed(response.data.message);
          onClose();
        }
      }
    } catch (error) {
      console.error("Error creating banners:", error);
    }
  };

  const [selectedFile, setSelectedFile] = useState(null);

  const handleFileChange = async (event) => {
    const file = event.target.files[0];
    let payloadData = {
      fileName: file.name,
      fileType: file.type,
    };
    const preSignedUrl = await apiClient.post("/home/s3/uploadFile", payloadData);
    console.log("preSignedUrl:", preSignedUrl);
    const response = await fetch(preSignedUrl.data.url, {
      method: "PUT",
      body: file,
    });
    console.log("Response:", response);
    setSelectedFile(file);
    if (response.ok) {
      console.log("File uploaded successfully");
      setFormData({
        ...formData,
        images: preSignedUrl.data.url.split("?")[0],
      });
    }
  };

  return (
    <Card id="add-banners">
      <MDBox p={4}>
        <form onSubmit={handleSubmit}>
          <Grid container spacing={3} lg={12}>
            <Grid item xs={12}>
              <FormControl fullWidth size="medium" sx={{ mt: 0 }}>
                <InputLabel id="state-label">Property</InputLabel>
                <Select
                  label="Property"
                  name="property"
                  value={formData.property}
                  onChange={handleChange}
                  required
                  sx={{
                    height: "46px",
                    display: "flex",
                    alignItems: "center",
                  }}
                >
                  <MenuItem value="">
                    <em>Select Property</em>
                  </MenuItem>
                  <MenuItem value="Chatham">Chatham St NW, Roanoke, VA 24012</MenuItem>
                  {property &&
                    property.length > 0 &&
                    property.map((item) => (
                      <MenuItem key={item.name} value={item.name}>
                        {item.name}
                      </MenuItem>
                    ))}
                </Select>
              </FormControl>
            </Grid>
            <Grid item xs={12}>
              <Button variant="text" component="label">
                <Input type="file" hidden onChange={handleFileChange} />
              </Button>
              <Grid item xs={6}>
                {selectedFile && (
                  <MDTypography variant="caption" mt={2} color="text" fontWeight="medium">
                    <strong>Selected file:</strong> {selectedFile.name}
                  </MDTypography>
                )}
              </Grid>
            </Grid>
            <Grid item xs={12}>
              <TextField
                fullWidth
                label="Sort"
                name="sort"
                value={formData.sort}
                onChange={handleChange}
                required
              />
            </Grid>
            <Grid item xs={12}>
              <Select
                fullWidth
                label="Status"
                name="status"
                value={formData.status}
                onChange={handleChange}
                sx={{ height: "40px" }}
              >
                <MenuItem value="Active">Active</MenuItem>
                <MenuItem value="Inactive">Inactive</MenuItem>
              </Select>
            </Grid>
            <Grid item xs={12}>
              <Button
                type="submit"
                variant="contained"
                color="primary"
                fullWidth
                sx={{ color: "#fff" }}
              >
                Submit
              </Button>
            </Grid>
          </Grid>
        </form>
      </MDBox>
    </Card>
  );
}

export default AddBanner;
